import { render, staticRenderFns } from "./GoLoginPop.vue?vue&type=template&id=b7aea94e&scoped=true"
import script from "./GoLoginPop.vue?vue&type=script&lang=js"
export * from "./GoLoginPop.vue?vue&type=script&lang=js"
import style0 from "./GoLoginPop.vue?vue&type=style&index=0&id=b7aea94e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7aea94e",
  null
  
)

export default component.exports